/* unplugin-vue-components disabled */import { render } from "./QuestionTypeFilter.vue?vue&type=template&id=2e2ee059"
import script from "./QuestionTypeFilter.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__